import styled from "styled-components";
import { TypographyProps } from "./types";

/**
 * Estilo do componente Typography
 * Configura as propriedades dinâmicas de cores, variantes, alinhamento e responsividade.
 */
export const StyledTypography = styled.span.withConfig({
  shouldForwardProp: (prop) =>
    !["variant", "color", "align", "weight", "uppercase", "italic"].includes(
      prop,
    ),
})<TypographyProps>`
  /* Integração com o tema */
  color: ${({ theme, color }) =>
    theme.colors[color as keyof typeof theme.colors] ||
    color ||
    theme.colors.darkGray};
  text-align: ${({ align }) => align || "left"};
  font-weight: ${({ theme, weight }) =>
    weight ? theme.fontWeights[weight] : theme.fontWeights.normal};
  text-transform: ${({ uppercase }) => (uppercase ? "uppercase" : "none")};
  font-style: ${({ italic }) => (italic ? "italic" : "normal")};
  font-family: ${({ theme }) => theme.fonts.primary};

  /* Variantes de texto */
  font-size: ${({ theme, variant }) => {
    switch (variant) {
      case "h1":
        return theme.fontSizes.xxl;
      case "h2":
        return theme.fontSizes.xl;
      case "h3":
        return theme.fontSizes.lg;
      case "body":
        return theme.fontSizes.md;
      case "caption":
        return theme.fontSizes.sm;
      case "label":
        return theme.fontSizes.xs;
      case "micro":
        return theme.fontSizes.xxs;
      default:
        return theme.fontSizes.md;
    }
  }};
  line-height: ${({ variant }) => {
    switch (variant) {
      case "h1":
        return "1.15";
      case "h2":
      case "h3":
        return "1.1";
      case "body":
        return "1.5";
      case "caption":
        return "1.5";
      case "label":
        return "1.2";
      default:
        return "1.5";
    }
  }};

  /* Responsividade */
  @media (max-width: ${({ theme }) => theme.breakpoints.xxl}) {
    font-size: ${({ theme, variant }) => {
      switch (variant) {
        case "h1":
          return theme.fontSizes.xl;
        case "h2":
          return theme.fontSizes.lg;
        case "h3":
          return theme.fontSizes.md;
        case "body":
          return theme.fontSizes.sm;
        case "label":
          return theme.fontSizes.xs;
        case "micro":
          return theme.fontSizes.xxs;
        default:
          return theme.fontSizes.sm;
      }
    }};
    line-height: ${({ variant }) =>
      ["h1", "h2", "h3"].includes(variant || "") ? "1.05" : "1.2"};
  }
`;
